import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { AppService, DomainTypes } from "../../../DomainTypes";
import { Catalogue } from "@singularsystems/neo-react-services";
import Pipeline from "../../../Models/Catalogue/Pipeline/Pipeline";
import DataCache from "../../../Services/DataCache";

export default class PipelineCatalogueEntry extends CatalogueEntry<Pipeline> {

    private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);

    constructor() {
        super("Pipelines", Pipeline);
        this.modalSize = 'xl'
    }

    public get editRole() {
        return CatalogueRoles.Pipelines.Edit;
    }

    public getFetchEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.getPipelines;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.pipelines;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.savePipelines;
    }

    public renderRow(pipeline: Pipeline, meta: Model.TransformMetaType<Pipeline>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.pipelineName} />
                <NeoGrid.Column bind={meta.startDate} />
                <NeoGrid.Column
                    bind={meta.capacityFunding}
                    appendText={"%"}
                    numProps={{ formatString: "#,##0.00" }}
                />
                <NeoGrid.Column
                    bind={meta.externalFunding}
                    appendText={"%"}
                    numProps={{ formatString: "#,##0.00" }}
                />
                <NeoGrid.Column
                    bind={meta.fundingRate}
                    appendText={"%"}
                    numProps={{ formatString: "#,##0.00" }}
                />
                <NeoGrid.Column
                    bind={meta.fundingRateNACM}
                    appendText={"%"}
                    numProps={{ formatString: "#,##0.00" }}
                />
                <NeoGrid.Column bind={meta.isFixedRate} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}